import { createRicosNodeExtension } from './create-ricos-extension';
export const doc = createRicosNodeExtension({
  groups: [],
  type: 'html-node',
  name: 'doc',
  createExtensionConfig() {
    return {
      name: this.name,
      topNode: true,
      content: 'block+',
      addAttributes: () => ({
        metadata: {},
        documentStyle: {},
      }),
    };
  },
});
